import { translate } from "@kaltura/mediaspace-shared-utils";
import { Button, Modal, ModalActions, ModalContent, ModalTitle, Typography } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";

export interface DeletePlaylistModalProps {
    playlistName: string;
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
    processing: boolean;
}

const StyledTypography = styled(Typography)({
    wordBreak: "break-word",
});

const baseClassName = "kms-ds-edit-playlist-info-delete-modal";

/**
 * PlaylistInfo Component - Handles the form for editing playlist information
 */
export const DeletePlaylistModal = (props: DeletePlaylistModalProps) => {
    const { playlistName, isOpen, onClose, onDelete, processing } = props;

    return (
        <Modal open={isOpen} className={`${baseClassName}`}>
            <ModalTitle className={`${baseClassName}-title`}>{translate("Delete Playlist")}</ModalTitle>
            <ModalContent className={`${baseClassName}-content`}>
                <StyledTypography>
                    {translate(`Are you sure you want to delete the playlist "%1"?`, [playlistName])}
                </StyledTypography>
            </ModalContent>
            <ModalActions className={`${baseClassName}-actions`}>
                <Button
                    variant="borderless"
                    color="secondary"
                    onClick={onClose}
                    className={`${baseClassName}-actions-button-cancel`}
                >
                    {translate("Cancel")}
                </Button>
                <Button
                    color="danger"
                    onClick={onDelete}
                    loading={processing}
                    className={`${baseClassName}-actions-button-delete`}
                >
                    {translate("Delete")}
                </Button>
            </ModalActions>
        </Modal>
    );
};
